import { Component, Inject } from '@angular/core';
import { FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { createRestrictionFormGroup } from '../../utils/restriction';
import { FacultyRestrictionItem } from '../../types';
import { RestrictionFormArray } from './types';
import { GENERIC_UNIT } from 'src/app/constants/restriction';

@Component({
  selector: 'app-faculties-selection-list-restriction-form-dialog',
  templateUrl:
    './faculties-selection-list-restriction-form-dialog.component.html',
  styleUrl: './faculties-selection-list-restriction-form-dialog.component.scss',
})
export class FacultiesSelectionListRestrictionFormDialogComponent {
  newRestrictions = new FormArray([createRestrictionFormGroup()]);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      addsRestrictions: (restrictions: RestrictionFormArray) => void;
    },
  ) {}

  addRestriction() {
    const newRestriction = createRestrictionFormGroup();

    this.newRestrictions.push(newRestriction);
  }

  handleRestrictions() {
    this.data.addsRestrictions(this.newRestrictions);
  }

  removeRestrictionAtIndex(restrictionIndex: number) {
    this.newRestrictions.removeAt(restrictionIndex);
  }

  isNonEditableRestriction(restriction: FacultyRestrictionItem): boolean {
    const unitValue = restriction.controls.unit.value;
    return (
      unitValue === GENERIC_UNIT.EXPIRATION_DATE ||
      unitValue === GENERIC_UNIT.LOCALITY
    );
  }
}
